import React, { FC, useState, useEffect } from 'react';
import ReactConfetti from 'react-confetti';

export const Confetti: FC = () => {
  const [showConfetti, changeShowConfetti] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      changeShowConfetti(true);
    }, 1000);
  }, []);

  return (
    <ReactConfetti
      run={showConfetti}
      width={window.innerWidth}
      height={window.innerHeight}
      numberOfPieces={250}
      gravity={0.15}
      recycle={false}
      colors={[
        '#E84055',
        '#0070F0',
        '#00ADF0',
        '#8ADFFF',
        '#FFD105',
        '#FFF576',
        '#092F56',
      ]}
    />
  );
};
